<p-dialog
  [header]="dialogHeader"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '440px', maxWidth: '90vw' }"
  [draggable]="false"
  [closable]="!loading()"
  [contentStyle]="{ overflow: 'hidden' }"
  (onHide)="onDialogHide()"
>
  <form autocomplete="off" (submit)="$event.preventDefault(); submit()">
    <div class="flex flex-col gap-4 py-2">
      <!-- Old Password (self-service only) -->
      @if (mode === 'self') {
        <div class="flex flex-col gap-2">
          <label class="text-sm font-medium text-gray-700">Current Password</label>
          <p-password
            name="oldPassword"
            autocomplete="current-password"
            [ngModel]="form.oldPassword()"
            (ngModelChange)="form.oldPassword.set($event)"
            [toggleMask]="true"
            [feedback]="false"
            styleClass="w-full"
            inputStyleClass="w-full box-border"
            placeholder="Enter current password"
            [disabled]="loading()"
          ></p-password>
        </div>
      }

      <!-- New Password -->
      <div class="flex flex-col gap-2">
        <label class="text-sm font-medium text-gray-700">New Password</label>
        <p-password
          name="newPassword"
          autocomplete="new-password"
          [ngModel]="form.newPassword()"
          (ngModelChange)="form.newPassword.set($event)"
          [toggleMask]="true"
          [feedback]="false"
          styleClass="w-full"
          inputStyleClass="w-full box-border"
          placeholder="Enter new password"
          [disabled]="loading()"
        ></p-password>

        @if (form.newPassword()) {
          <ul class="text-xs mt-1 space-y-1">
            <li
              [ngClass]="rules().length
                ? 'text-green-600 dark:text-green-400'
                : 'text-red-500 dark:text-red-400'"
            >
              <i class="pi" [ngClass]="rules().length ? 'pi-check' : 'pi-times'"></i>
              At least 8 characters
            </li>
            <li
              [ngClass]="rules().lower
                ? 'text-green-600 dark:text-green-400'
                : 'text-red-500 dark:text-red-400'"
            >
              <i class="pi" [ngClass]="rules().lower ? 'pi-check' : 'pi-times'"></i>
              One lowercase letter (a-z)
            </li>
            <li
              [ngClass]="rules().upper
                ? 'text-green-600 dark:text-green-400'
                : 'text-red-500 dark:text-red-400'"
            >
              <i class="pi" [ngClass]="rules().upper ? 'pi-check' : 'pi-times'"></i>
              One uppercase letter (A-Z)
            </li>
            <li
              [ngClass]="rules().digit
                ? 'text-green-600 dark:text-green-400'
                : 'text-red-500 dark:text-red-400'"
            >
              <i class="pi" [ngClass]="rules().digit ? 'pi-check' : 'pi-times'"></i>
              One number (0-9)
            </li>
            <li
              [ngClass]="rules().special
                ? 'text-green-600 dark:text-green-400'
                : 'text-red-500 dark:text-red-400'"
            >
              <i class="pi" [ngClass]="rules().special ? 'pi-check' : 'pi-times'"></i>
              One special character (~ ! &#64; # $ % &amp; * _ - + =)
            </li>
          </ul>
        }
      </div>

      <!-- Confirm Password -->
      <div class="flex flex-col gap-2">
        <label class="text-sm font-medium text-gray-700">Confirm Password</label>
        <p-password
          name="confirmPassword"
          autocomplete="new-password"
          [ngModel]="form.confirmPassword()"
          (ngModelChange)="form.confirmPassword.set($event)"
          [toggleMask]="true"
          [feedback]="false"
          styleClass="w-full"
          inputStyleClass="w-full box-border"
          placeholder="Re-enter new password"
          [disabled]="loading()"
        ></p-password>
      </div>

      @if (errorMessage()) {
        <p class="text-sm text-red-600">{{ errorMessage() }}</p>
      }
    </div>
  </form>

  <ng-template pTemplate="footer">
    <p-button
      label="Cancel"
      severity="secondary"
      outlined
      [disabled]="loading()"
      (onClick)="close()"
    ></p-button>
    <p-button
      label="Save"
      severity="primary"
      [loading]="loading()"
      (onClick)="submit()"
    ></p-button>
  </ng-template>
</p-dialog>